import { render } from "./filter-component.vue?vue&type=template&id=10f80575"
import script from "./filter-component.vue?vue&type=script&lang=ts"
export * from "./filter-component.vue?vue&type=script&lang=ts"

import "./filter-component.vue?vue&type=style&index=0&id=10f80575&lang=less"
script.render = render

export default script